import { memo, useCallback } from 'react';
import { Link } from 'react-router';

import { Text, Image, Box } from '@betty/moonlight';
import React from 'react';
import Accordion from '../../../../components/Accordion/Accordion';
import AccordionItem from '../../../../components/Accordion/AccordionItem';
import { useDispatch } from '@betty/toolkit/state';
import { openChat } from '@betty/chat/state';

function FAQsSection() {
  const dispatch = useDispatch();

  const onChatPress = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  return (
    <Box gap="space-600">
      <Text variant="h4" gradient="darkSurfaceAccent">
        FAQs
      </Text>
      <Box
        flexDirection="row"
        gap="space-400"
        alignItems="center"
        justifyContent="center"
      >
        <Box flex={3}>
          <Accordion className="faq-content">
            <AccordionItem title="Is Betty safe?">
              <>
                <Text variant="body-m" color="darkSurfacePrimary">
                  We are licensed and regulated by{' '}
                  <Link to="https://www.agco.ca">
                    Alcohol and Gaming Commission of Ontario
                  </Link>{' '}
                  and managed by{' '}
                  <Link to="https://igamingontario.ca">iGaming Ontario</Link>.
                  You can be assured that we operate with the highest standards
                  of integrity and fairness. Additionally, we take responsible
                  gaming seriously and offer tools to help you stay in control.
                  With Betty, you can sit back, relax, and enjoy the thrill of
                  online gaming with the utmost confidence that you&apos;re in
                  safe hands.
                </Text>
              </>
            </AccordionItem>
            <AccordionItem title="Where is Betty based?">
              <Text variant="body-m" color="darkSurfacePrimary">
                Betty is based in Ontario. Our team collaborated with over 300
                players to create the ultimate online casino for slot lovers. We
                offer local support that&apos;s accessible whenever you need
                assistance. Reach out to us directly to speak with the Betty
                Support team, fully staffed by real humans and unscripted.
                Contact us on
                <span onClick={onChatPress}>
                  {' '}
                  <Text
                    variant="body-m"
                    color="darkSurfaceAccentSolid"
                    underline
                  >
                    Live Chat
                  </Text>{' '}
                </span>
                for immediate help.
              </Text>
            </AccordionItem>
            <AccordionItem title="What makes Betty unique?">
              <ol className="faq-list">
                <li className="faq-li">
                  <Text variant="body-m" color="darkSurfacePrimary">
                    Curated selection of games: Our experts have handpicked the
                    most popular and entertaining slot games, so you don&apos;t
                    waste any time looking for your next favourite game.
                  </Text>
                </li>

                <li className="faq-li">
                  <Text variant="body-m" color="darkSurfacePrimary">
                    Loyalty Program: Betty offers a unique loyalty program where
                    you earn level points and coins with every spin. As you
                    spin, you will see your level progress and coin balance
                    increase. When you level up, you will receive exciting
                    surprises and bonuses.
                  </Text>
                </li>
                <li className="faq-li">
                  <Text variant="body-m" color="darkSurfacePrimary">
                    Zero Playthrough Bonuses: At Betty, we believe in giving you
                    bonuses with no strings attached. Our zero playthrough
                    bonuses allow you to have fun and enjoy your winnings
                    without having to worry about complicated terms and
                    conditions.
                  </Text>
                </li>
              </ol>
            </AccordionItem>
            <AccordionItem title="How do bonuses work?">
              <Text variant="body-m" color="darkSurfacePrimary">
                At Betty, we believe in straightforward and fair bonuses. With
                our free spin offers, you will have 48 hours to use the free
                spins before they expire. You keep what you win, without any
                hidden requirements. You can withdraw them anytime, as long as
                you meet the minimum withdrawal requirement.
              </Text>
            </AccordionItem>
            <AccordionItem title="How fast are withdrawals?">
              <Text variant="body-m" color="darkSurfacePrimary">
                We understand the importance of fast and hassle-free
                withdrawals. That&apos;s why over 90% of withdrawals are
                processed immediately and transferred right back into your bank
                account within minutes. If we need additional information from
                you to process your withdrawal, we will reach out within 24
                hours to ensure a speedy process. Our dedicated Betty Support
                team is always available to answer any questions. Simply contact
                us on
                <span onClick={onChatPress}>
                  {' '}
                  <Text
                    variant="body-m"
                    color="darkSurfaceAccentSolid"
                    underline
                  >
                    Live Chat
                  </Text>
                </span>
                .
              </Text>
            </AccordionItem>
            <AccordionItem title="Does Betty have an app?">
              <Text variant="body-m" color="darkSurfacePrimary">
                Play your favourite games, check offers, and enjoy smooth,
                secure gameplay - anytime, anywhere. Now available on both{' '}
                <a
                  href="https://apps.apple.com/ca/app/betty-casino-real-money-slots/id6743212841"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  iOS
                </a>{' '}
                and{' '}
                <a
                  href="https://play.google.com/store/apps/details?id=ca.betty.app&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Android
                </a>
                ! Download the app today and start playing.
              </Text>
            </AccordionItem>

            <AccordionItem title="How do I get Free Spins?">
              <>
                <Text variant="body-m-semi" color="darkSurfacePrimary">
                  There are a few ways to score Free Spins at Betty:
                </Text>
                <ul>
                  <li>
                    <Text variant="body-m" color="darkSurfacePrimary">
                      Welcome Bonuses - Get Free Spins when you make your first,
                      second, and third deposits.
                    </Text>
                  </li>
                  <li>
                    <Text variant="body-m" color="darkSurfacePrimary">
                      Betty Coins – Earn as you play and redeem in the Betty
                      Shop for Free Spins and more.
                    </Text>
                  </li>
                  <li>
                    <Text variant="body-m" color="darkSurfacePrimary">
                      Special Promotions – Keep an eye out for in-app and email
                      promos featuring Free Spins.
                    </Text>
                  </li>
                </ul>
              </>
            </AccordionItem>
            <AccordionItem title="How do I refer a friend?">
              <Text variant="body-m" color="darkSurfacePrimary">
                If you’re loving Betty, you can invite your friends to join the
                fun too. We offer a sweet referral bonus when they sign up—just
                check your account for your unique link and start sharing the
                love.
              </Text>
            </AccordionItem>
          </Accordion>
        </Box>
        <Box
          display={{
            desktop: 'flex',
            tablet: 'none',
            mobile: 'none',
          }}
          flex={2}
        >
          <Image
            name="landingPage.torontoB"
            width="100%"
            aspectRatio={2 / 3}
            maxHeight={500}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(FAQsSection);
